const api = "https://api.eparceiro.focosistemas.com.br/";

export default api;
